// src/firebase.js

import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getAnalytics, isSupported } from 'firebase/analytics';

// Optional: Log an error if any required Firebase env var is missing.
// This helps catch typos or missing values in your .env file.
const requiredEnvVars = [
  'REACT_APP_FIREBASE_API_KEY',
  'REACT_APP_FIREBASE_AUTH_DOMAIN',
  'REACT_APP_FIREBASE_PROJECT_ID',
  'REACT_APP_FIREBASE_STORAGE_BUCKET',
  'REACT_APP_FIREBASE_MESSAGING_SENDER_ID',
  'REACT_APP_FIREBASE_APP_ID',
  // measurementId is optional; comment this out if you don’t need analytics
  'REACT_APP_FIREBASE_MEASUREMENT_ID',
];

requiredEnvVars.forEach((key) => {
  if (!process.env[key]) {
    console.error(
      `Environment variable ${key} is missing. Check your .env file.`
    );
  }
});

// Use environment variables for all config values
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  // measurementId is optional; only needed if you want analytics
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

// Initialize the Firebase app
const app = initializeApp(firebaseConfig);

// Export core Firebase services
export const auth = getAuth(app);       // For Authentication
export const db = getFirestore(app);    // For Firestore Database
export const storage = getStorage(app); // For Cloud Storage

// Initialize Analytics (if supported in this environment)
let analytics = null;
if (typeof window !== 'undefined') {
  isSupported().then((supported) => {
    if (supported) {
      analytics = getAnalytics(app);
    }
  });
}

export { analytics };
export default app;
